async function signInWithProductAuth(client, email, password) {
  if (typeof email !== 'string' || email.trim() === '' || typeof password !== 'string' || password === '') {
    const error = new Error('Email and password required');
    error.status = 400;
    return { data: null, error };
  }
  if (!client || !client.auth || typeof client.auth.signInWithPassword !== 'function') {
    const error = new Error('Supabase Auth is not configured');
    error.status = 503;
    return { data: null, error };
  }
  return client.auth.signInWithPassword({ email, password });
}

module.exports = { signInWithProductAuth };
